var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type === 'textarea' ? 'textarea' : 'input',_vm._b({key:_vm.name,tag:"component",attrs:{"value":_vm.value},on:{"input":_vm.handleInput}},'component',this.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }